/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, message, Modal} from 'antd'
import React, { useEffect, useState } from 'react'
import SendTitleCompany from './SendTitleCompany';
import DocumentList from './DocumentList';
import { useDispatch, useSelector } from 'react-redux';
import { transactionLaneDataHandle } from '../state/actions';
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';
import EmailPreview from '../../PropertyComp/components/EmailPreview';

const TitleCompanyDocument = ({ selectedData, setSendCompanyModal, selectedStatus, section }) => {
  const delegate = (section === "DELEGATE");
  const bos = (section === "BOS");
  const [modalstep,setModalStep]=useState(0)
  const [selectedtext, setSelectedText] = useState("");
  const [emailSignatureId, setEmailSignatureId] = useState({});
  const [emailPreviewClients,setEmailPreviewClients]=useState([])
  const [data,setData] = useState({
    selectedPerson: [],
    personData: [],
    emailMessage: "",
    documentSelected: [],
    sharedSelected: [],
    propertyDocsSelected:[],
    documentWithoutBuyerSelected: [],
    customerDocumentSelected: [],
  });
  const [ispreview, setIspreview] = useState({
    signaturePreview: false,
    emailPreview: false,
  });
  const [form] = Form.useForm();
  const [subjectForm] = Form.useForm()
  const { getTitleCompanySelectedData } = useSelector((state) => state.rtdTransactionLane);
  const {emailPreviewData,emailPreviewLoading} = useSelector((state) => state.PropertyReducer);
  const dispatch = useDispatch();

  const handleOpenEmailPreview = () => {
    setIspreview({ ...ispreview, emailPreview: true });
    handleSend("emailPreview");
  
    const arr = data?.personData
      ?.filter((el) => data?.selectedPerson?.includes(el?.key))
      ?.map((el) => {
        const baseData = {
          ...(el?._id ? { clientId: el._id } : {}),
          clientType: el?._id ? "Title_Company_Rep" : "Title_Company_Manual_Client",
        };
  
        if (!el?._id) {
          return {
            ...baseData,
            Name: el?.name,
            email: el?.email,
          };
        }
  
        return baseData;
      });
  
    setEmailPreviewClients([...arr]);
  };
  useEffect(() => {
    if (ispreview?.emailPreview && emailPreviewData) {
      const emailPreviewProps = {
        ispreview,
       
        subjectForm,
        emailSignatureId,
        emailPreviewClients,
       
        emailPreviewData,
        emailPreviewLoading // ✅ Ensure Redux data is included
      };
  
      localStorage.setItem("emailPreviewProps", JSON.stringify(emailPreviewProps));
      window.open("/emailPreview", "_blank");
      
      // Reset state after opening the new tab
      // setEmailPreviewReady(false);
    }
  }, [ispreview?.emailPreview, emailPreviewData]);
  const getClientDocName = (data,name) => {
    let {contractType, transactionData = {}} = data;
    switch (contractType) {
      case 'ERTL':
      case 'ETCT':
      case 'ERTB': 
      case 'CB_ERTB': {
        let startDate = transactionData?.ListingPeriodBeginDate
          ? moment(transactionData?.ListingPeriodBeginDate).format("MM/DD/YYYY, h:mm A")
          : '';
        let endDate = transactionData?.ListingPeriodEndByDate
          ? moment(transactionData?.ListingPeriodEndByDate).format("MM/DD/YYYY, h:mm A")
          : '';
        return (
          startDate && endDate ?`${name} ${startDate} - ${endDate} `:
          startDate?`${name} ${startDate}`:
          endDate?`${name} ${endDate}`:
          `${name}`
        )
      }
      case 'LCAE': 
      case 'LCAES_ETCT':{
        let endDate = transactionData?.ListingPeriodEndByDate
          ? moment(transactionData?.ListingPeriodEndByDate).format("MM/DD/YYYY, h:mm A")
          : '';
        return (endDate ?`Amend/Extend -  ${endDate}`:`Amend/Extend`);
      }
  
      default:
        let dateTime = data?.createdAt
          ? moment(data?.createdAt).format("MM/DD/YYYY, h:mm A")
          : '';
        return `${name} ${dateTime}`;
    }
  };

  const processClientDocs = (docsTabDoraDocs=[]) => {
    let clientDocuments = [];
    docsTabDoraDocs?.forEach((doc) => {
      if (doc.createdDocuments?.length > 0) {
        doc.createdDocuments.forEach((subDoc) => {
          subDoc.contractName = getClientDocName(subDoc, doc?.name);
          clientDocuments.push(subDoc);
          if (subDoc.matchedDocuments?.length > 0) {
            subDoc.matchedDocuments.forEach((matchDocument) => {
              matchDocument.contractName = getClientDocName(matchDocument);
              matchDocument.isSecondLevel = true;
              clientDocuments.push(matchDocument);
            });
          }
        });
      }
    });
    return clientDocuments;
  };

  const next = () => {
    setModalStep(modalstep + 1);
  };

  const prev = () => {
    setModalStep(modalstep - 1);
    setData((previous)=>({
      ...previous,
      documentSelected: [],
      sharedSelected: [],
      propertyDocsSelected:[],
      documentWithoutBuyerSelected: []
    }))
  };

  const onClose=()=>{
    setSendCompanyModal(false)
  }

  useEffect(() => {
    let processorsArr = [], affiliatesArr = [];

    if(getTitleCompanySelectedData?.processors?.length){
      getTitleCompanySelectedData?.processors?.map((el,i) => {
        processorsArr.push({
          _id: null,
          name: el?.name,
          email: el?.email,
          key: uuidv4()
        })
      })
    }

    if(getTitleCompanySelectedData?.affiliateDetails?.affiliates?.length){
      getTitleCompanySelectedData?.affiliateDetails?.affiliates?.map((el,i) => {
        affiliatesArr.push({
          _id: null,
          name: el?.name,
          email: el?.email,
          key: uuidv4()
        })
      })
    }

    let flag=[]
    // Initial state of arr based on default selected rows
    flag = [
      ...(getTitleCompanySelectedData?.titleCloserEmail ? [{
        _id: getTitleCompanySelectedData?.titleCloserId || null,
        name: getTitleCompanySelectedData?.titleCloserName,
        email: getTitleCompanySelectedData?.titleCloserEmail,
        key: uuidv4()
      }] : []),
      ...(getTitleCompanySelectedData?.salesRepEmail ? [{
        _id: getTitleCompanySelectedData?.salesRepId || null,
        name: getTitleCompanySelectedData?.salesRepName,
        email: getTitleCompanySelectedData?.salesRepEmail,
        key: uuidv4()
      }] : []),
      ...(getTitleCompanySelectedData?.titleOfficeEmail ? [{
        _id: getTitleCompanySelectedData?.titleOfficeId || null,
        name: getTitleCompanySelectedData?.titleOfficeName,
        email: getTitleCompanySelectedData?.titleOfficeEmail,
        key: uuidv4()
      }] : []),
      ...(processorsArr?.length ? processorsArr : []),
      ...(affiliatesArr?.length ? affiliatesArr : []),
    ];
    setData({
      ...data,
      personData: [ ...(data?.personData), ...flag ]
    });
  }, []);

  const handleSend=(source)=>{
    let manualEmails = [];
    let ids = [];
    data?.personData?.forEach((element)=>{
      if(data?.selectedPerson?.includes(element?.key)){
        if(element?._id)   {
          if(source==="emailPreview"){
            if(getTitleCompanySelectedData?.titleOfficeId){
              ids.push(element?._id)
            }else{
              ids.push({
                id: element._id,
                clientType: "Title_Company_Rep"
              });
            }
          }else{
            if(getTitleCompanySelectedData?.titleOfficeId){
              ids.push(element?._id)
            }else{
              ids.push({
                id: element._id,
               });
            }
          }
           
      } 
        else{
            if(source==="emailPreview"){
              manualEmails.push({
                fullName: element?.name,
                email: element?.email,
                //email preview
                clientType:"Title_Company_Manual_Client"
              });
            }else{
              manualEmails.push({
                fullName: element?.name,
                email: element?.email,

              });
            }
         
        }
        } 
    })
    const subjectVal = subjectForm?.getFieldValue("subject");
    const payload={
      ...((data.documentSelected.length || data?.propertyDocsSelected?.length || data?.documentWithoutBuyerSelected || data?.customerDocumentSelected) ? {documentIds: [...data?.documentSelected, ...data?.propertyDocsSelected, ...data?.documentWithoutBuyerSelected, ...data?.customerDocumentSelected]} : {}),
      ...((getTitleCompanySelectedData?.titleOfficeId && ids.length) ? {
        sentTo: {
          titleOfficeId: getTitleCompanySelectedData.titleOfficeId,
          ids
        }
      } : {}),
      propertyId: selectedData.propertyId,
      offerId: selectedData.offerId,
      ...(delegate ? { delegateSide: selectedStatus, delegateOwnerId: selectedData?.currentAgentId?._id} : (bos && {delegateOwnerId: selectedData?.currentAgentId?._id, screenType: "BOS"})),
      sentBy: (selectedStatus === "SELLER") ? "SELLER_AGENT" : "BUYER_AGENT",
      ...(data.emailMessage ? {emailMessage: data.emailMessage} : {}),
      ...(manualEmails.length ? {readOnlyEmailsArray: manualEmails} : {}),
      ...(data.sharedSelected.length ? {sharedFolderDocsArray: data.sharedSelected} : {}),
      ...((emailSignatureId?.isDefault && emailSignatureId?._id) ? {emailSignatureId:emailSignatureId?._id}:{}),
      ...(subjectVal?.length ? {subject: subjectVal} : {}),
      ...(source==="emailPreview"?{showEmailPreview:true}:{})
    }
    dispatch(transactionLaneDataHandle.sendTitleCompanyDocument(payload,"emailPreview"))
    if(source!=="emailPreview"){
    setSendCompanyModal(false)
    }
  }

  const steps = [
    {
      title:  <div style={{cursor:"pointer",fontSize:"16px"}}>First</div>,
      content: (
        <SendTitleCompany
          selectedtext={selectedtext}
          setSelectedText={setSelectedText}
          data={data}
          setData={setData}
          emailSignatureId={emailSignatureId}
          setEmailSignatureId={setEmailSignatureId}
          subjectForm={subjectForm}
        />
      ),

    },
    {
      title:  <div><text style={{ fontSize:"16px" }}>Second</text></div>,
      content: (
        <DocumentList
            setData={setData}
            data={data}
            selectedData={selectedData}
            section={section}
            role={selectedStatus}
            reloadSection="RTD"
            RTDInitiator={selectedStatus}
            processClientDocs={processClientDocs}
        />
      ),
    }
  ];

  const handleEmailAddress = (value) => {
    let emailPresent = data?.personData?.filter((el) => el?.email === value?.email);
    if(emailPresent?.length === 0){
      const uniqueId = uuidv4();
      setData({ ...data, personData: [...(data?.personData), { _id: null, email: value?.email, key: uniqueId, name: value?.fullName}], selectedPerson: [ ...(data?.selectedPerson), uniqueId ] });
      form.resetFields();
    }else{
      message.info("This email is already added!")
    }
  };

  return (
    <>
    {ispreview?.emailPreview && <EmailPreview
    ispreview={ispreview} setIspreview={setIspreview} 
    personsArray={data?.selectedPerson} 
    // RTDInitiator={RTDInitiator} role={role} allBuyerAgentData={allBuyerAgentData} allSellerAgentData={allSellerAgentData} combinedTitleCompanyData={combinedTitleCompanyData} selectedPersonsState={selectedPersonsState} 
    subjectForm={subjectForm} emailSignatureId={emailSignatureId}  
    emailPreviewClients={emailPreviewClients}
    />}
    
    <Modal
      title="Send Documents"
      visible={true}
      onCancel={onClose}
      footer={null}
      width={800}
      style={{marginTop: "-50px"}}
    >
      <div style={{marginTop:"-10px"}}>
        {modalstep === 0 && <Form style={{ width: "100%", textAlign: "center", display: "flex", justifyContent: "center", gap: "10px" }} form={form} onFinish={handleEmailAddress}>
          <Form.Item
            name="fullName"
            rules={[
              { required: true, message: "Please enter full name!" },
              { whitespace: true }
            ]}
          >
            <Input style={{ width: "250px", height: "32px" }} placeholder="Enter full name" type='text'/>
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Please enter email!" },
              {
                type: 'email',
                message: 'Please enter a valid email!',
              },
            ]}
          >
            <Input style={{ width: "250px", height: "32px" }} placeholder="Enter email address" type="email" />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary">
              Submit
            </Button>
          </Form.Item>
        </Form>}
        <div className="steps-content" style={{ marginTop: "20px",height:"420px",overflowY:"auto"}}>
          {steps[modalstep]?.content}
        </div>

        <div className="steps-action" style={{ marginTop: "25px" }}>

          {
            (modalstep === 1) && <Button
              style={{ margin: "0 8px", }}
              onClick={() => prev()}
            >
              Previous
            </Button>
          }
          {
            (modalstep === 0) && <Button
              type="primary"
              disabled={!(data?.selectedPerson?.length)}
              style={{margin: "0 8px"}}
              onClick={() => next()}
            >
              Next
            </Button>
          }
          {
            (modalstep === 1) && <Button type="primary" 
            onClick={handleOpenEmailPreview}
            disabled={!(data?.sharedSelected?.length || data?.documentSelected?.length || data?.propertyDocsSelected?.length || data?.documentWithoutBuyerSelected?.length || data?.customerDocumentSelected?.length)}
            >
              Email Preview
            </Button>
          }
          {
            (modalstep === 1) && <Button
              type="primary"
              disabled={!(data?.sharedSelected?.length || data?.documentSelected?.length || data?.propertyDocsSelected?.length || data?.documentWithoutBuyerSelected?.length || data?.customerDocumentSelected?.length)}
              style={{
                margin: "0 8px",
              }}
              onClick={handleSend}
            >
              Send
            </Button>
          }
        </div>
      </div>
    </Modal>
    </>
  )
}

export default TitleCompanyDocument
